export default {"src":"/_next/static/media/trampoline.09700fbd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};